export default __webpack_public_path__ + "static/media/submenu-blue.44ea134f.svg";